export default __webpack_public_path__ + "static/media/info.ebd21df4.svg";